import { addLabels } from "@otto-ec/global-resources/apm";
import type { LCPMetricWithAttribution, Metric } from "web-vitals/attribution";
import { collectLCPAttribution, webVitalsToMetricMap } from "./metrics";
import type { RawRumData } from "../utils/util";

const labelsPrefix = "marks_";

/**
 *
 *
 *
 *
 */
export const addLcpApmLabels = async (
  metric: LCPMetricWithAttribution,
): Promise<void> => {
  const metricsResult: RawRumData = {};
  collectLCPAttribution(metric, metricsResult, labelsPrefix);
  return addLabels(metricsResult);
};

/**
 *
 *
 */
export const addApmLabels = async (metric: Metric): Promise<void> =>
  addLabels({
    [`${labelsPrefix}${webVitalsToMetricMap[metric.name]}`]: metric.value,
  });
